import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { upperFirst } from 'lodash-es';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';
import shuffleCaregiverServices from '@/utils/shuffleCaregiverServices';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

interface CaregiverServicesProps {
  caregiver: Caregiver;
}

const CaregiverServices = ({ caregiver }: CaregiverServicesProps) => {
  const {
    member: { displayName },
    profiles,
  } = caregiver;
  const { shuffleSeed = 1 } = usePageAttributes();
  const supportedServices = profiles?.commonCaregiverProfile?.supportedServices ?? null;

  const services = useMemo(() => {
    const servicesList = shuffleCaregiverServices(supportedServices, shuffleSeed).map(
      (service, idx) => (idx === 0 ? upperFirst(service) : service)
    );

    if (servicesList.length >= 6) {
      return `${servicesList.join(', ')} & more`;
    }

    return servicesList.join(', ');
  }, [supportedServices, shuffleSeed]);
  const displayServicesLabel = `${displayName.slice(
    0,
    displayName.length - 3
  )} can also help with:${' '}`;

  if (services.length === 0) {
    return null;
  }

  return (
    <Box alignItems="center" mt={1.5}>
      <Typography component="span" variant="body2" fontWeight="700">
        {displayServicesLabel}
      </Typography>
      <Typography component="span" variant="body2" fontStyle="italic">
        {services}
      </Typography>
    </Box>
  );
};

export default CaregiverServices;
